const map = {
  months: 'Mensal',
  days: 'Diario',
}

export default str => map[str] || str
